import { Routes } from '@angular/router';
import { environment } from './../environments/environment';

export const routes: Routes = [
  {
    path: 'a',
    loadComponent: () => import('./homepage/homepage.page').then( m => m.HomepagePage)
  },
  {
    path: '',
    loadComponent: () => import('./homepage/homepage.page').then( m => m.HomepagePage)
  },
  {
    path: 'homepage',
    loadComponent: () => import('./homepage/homepage.page').then( m => m.HomepagePage)
  },
  {
    path: 'homepage/post/:postId',
    loadComponent: () => import('./homepage/homepage.page').then( m => m.HomepagePage)
  },
  {
    path: 'homepage/:segment',
    loadComponent: () => import('./homepage/homepage.page').then( m => m.HomepagePage)
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'user-profile-create/organization/:type',
    loadComponent: () => import('./userProfile/user-profile-create/user-profile-create.page').then( m => m.UserProfileCreatePage)
  },
  {
    path: 'user-profile-create',
    loadComponent: () => import('./userProfile/user-profile-create/user-profile-create.page').then( m => m.UserProfileCreatePage)
  },
  {
    path: 'user-profile-update',
    loadComponent: () => import('./userProfile/user-profile-update/user-profile-update.page').then( m => m.UserProfileUpdatePage)
  },
  {
    path: 'password-lost',
    loadComponent: () => import('./password/password-lost/password-lost.page').then( m => m.PasswordLostPage)
  },
  {
    path: 'password-reset/:key',
    loadComponent: () => import('./password/password-reset/password-reset.page').then( m => m.PasswordResetPage)
  },
  {
    path: 'animal-list',
    loadComponent: () => import('./animal/animal-list/animal-list.page').then( m => m.AnimalListPage)
  },
  {
    path: 'animal-update',
    loadComponent: () => import('./animal/animal-update/animal-update.page').then( m => m.AnimalUpdatePage)
  },
  {
    path: 'animal-update/:animalId',
    loadComponent: () => import('./animal/animal-update/animal-update.page').then( m => m.AnimalUpdatePage)
  },
  ['SonEspaceSante', 'SonEspaceEleveur'].includes(environment.APP_VERSION) ? {
    path: 'animal-add',
    loadComponent: () => import('./animal/animal-add/animal-add.page').then( m => m.AnimalAddPage)
  }: {
    path: 'animal-add',
    redirectTo: 'animal-update',
    pathMatch: 'full'
  },
  {
    path: 'event-list',
    loadComponent: () => import('./agenda/event-list/event-list.page').then( m => m.EventListPage)
  },
  {
    path: 'event-add/:type',
    loadComponent: () => import('./agenda/event-update/event-update.page').then( m => m.EventUpdatePage)
  },
  {
    path: 'event-add/:type/:defaultAnimalId',
    loadComponent: () => import('./agenda/event-update/event-update.page').then( m => m.EventUpdatePage)
  },
  {
    path: 'event-update',
    loadComponent: () => import('./agenda/event-update/event-update.page').then( m => m.EventUpdatePage)
  },
  {
    path: 'event-update/:eventId',
    loadComponent: () => import('./agenda/event-update/event-update.page').then( m => m.EventUpdatePage)
  },
  {
    path: 'event-report/:eventId',
    loadComponent: () => import('./agenda/event-report/event-report.page').then( m => m.EventReportPage)
  },
  {
    path: 'animal-fiche/:animalId',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then( m => m.AnimalFichePage)
  },
  {
    path: 'animal-fiche/:animalId/:segment/:vaccineValenceId',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then( m => m.AnimalFichePage)
  },
  {
    path: 'animal-fiche/:animalId/:segment',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then( m => m.AnimalFichePage)
  },
  {
    path: 'mentions-legales',
    loadComponent: () => import('./mentions-legales/mentions-legales.page').then( m => m.MentionsLegalesPage)
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.page').then( m => m.ContactPage)
  },
  {
    path: 'user-profile-delete',
    loadComponent: () => import('./userProfile/user-profile-delete/user-profile-delete.page').then( m => m.UserProfileDeletePage)
  },
  {
    path: 'clinic-contact-list',
    loadComponent: () => import('./clinic/clinic-contact-list/clinic-contact-list.page').then( m => m.ClinicContactListPage)
  },
  {
    path: 'clinic-contact-update/:clinicContactId',
    loadComponent: () => import('./clinic/clinic-contact-update/clinic-contact-update.page').then( m => m.ClinicContactUpdatePage)
  },
  {
    path: 'clinic-contact-update',
    loadComponent: () => import('./clinic/clinic-contact-update/clinic-contact-update.page').then( m => m.ClinicContactUpdatePage)
  },
  {
    path: 'pharmacy-product-list',
    loadComponent: () => import('./pharmacy/pharmacy-product-list/pharmacy-product-list.page').then( m => m.PharmacyProductListPage)
  },
  {
    path: 'animal-share-list',
    loadComponent: () => import('./animal/animal-share-list/animal-share-list.page').then( m => m.AnimalShareListPage)
  },
  {
    path: 'animal-share-update',
    loadComponent: () => import('./animal/animal-share-update/animal-share-update.page').then( m => m.AnimalShareUpdatePage)
  },
  {
    path: 'animal-share-update/:animalShareId',
    loadComponent: () => import('./animal/animal-share-update/animal-share-update.page').then( m => m.AnimalShareUpdatePage)
  },
  {
    path: 'animal-sharewithme-update/:animalShareId',
    loadComponent: () => import('./animal/animal-sharewithme-update/animal-sharewithme-update.page').then( m => m.AnimalSharewithmeUpdatePage)
  },
  {
    path: 'organization-member-list',
    loadComponent: () => import('./organization/organization-member-list/organization-member-list.page').then( m => m.OrganizationMemberListPage)
  },
  {
    path: 'organization-member-update',
    loadComponent: () => import('./organization/organization-member-update/organization-member-update.page').then( m => m.OrganizationMemberUpdatePage)
  },
  {
    path: 'organization-member-update/:organizationMemberId',
    loadComponent: () => import('./organization/organization-member-update/organization-member-update.page').then( m => m.OrganizationMemberUpdatePage)
  },
  {
    path: 'plan',
    loadComponent: () => import('./map/plan/plan.page').then( m => m.PlanPage)
  },
  {
    path: 'plan/:action/:mapPlanItemId',
    loadComponent: () => import('./map/plan/plan.page').then( m => m.PlanPage)
  },
  {
    path: 'organization-update',
    loadComponent: () => import('./organization/organization-update/organization-update.page').then( m => m.OrganizationUpdatePage)
  },
  {
    path: 'organization-fiche',
    loadComponent: () => import('./organization/organization-fiche/organization-fiche.page').then( m => m.OrganizationFichePage)
  },
  {
    path: 'organization-public-animals/:organizationId',
    loadComponent: () => import('./organization/public/organization-public-animals/organization-public-animals.page').then( m => m.OrganizationPublicAnimalsPage)
  },
  {
    path: 'organization-public-animals/:organizationId/:animalId',
    loadComponent: () => import('./organization/public/organization-public-animals/organization-public-animals.page').then( m => m.OrganizationPublicAnimalsPage)
  },
  {
    path: 'animal-owner/:animalId',
    loadComponent: () => import('./animal/animal-owner/animal-owner.page').then( m => m.AnimalOwnerPage)
  },
  {
    path: 'organization-fosterfamily-list',
    loadComponent: () => import('./organization/organization-fosterfamily-list/organization-fosterfamily-list.page').then( m => m.OrganizationFosterfamilyListPage)
  },
  {
    path: 'organization-fosterfamily-update',
    loadComponent: () => import('./organization/organization-fosterfamily-update/organization-fosterfamily-update.page').then( m => m.OrganizationFosterfamilyUpdatePage)
  },
  {
    path: 'organization-fosterfamily-update/:fosterFamilyId',
    loadComponent: () => import('./organization/organization-fosterfamily-update/organization-fosterfamily-update.page').then( m => m.OrganizationFosterfamilyUpdatePage)
  },
  {
    path: 'organization-flowcontrol',
    loadComponent: () => import('./organization/organization-flowcontrol/organization-flowcontrol.page').then( m => m.OrganizationFlowcontrolPage)
  },
  {
    path: 'organization-flowcontrol/:set/:animalId',
    loadComponent: () => import('./organization/organization-flowcontrol/organization-flowcontrol.page').then( m => m.OrganizationFlowcontrolPage)
  },
  {
    path: 'organization-walking',
    loadComponent: () => import('./organization/organization-walking/organization-walking.page').then( m => m.OrganizationWalkingPage)
  },
  {
    path: 'organization-stats',
    loadComponent: () => import('./organization/organization-stats/organization-stats.page').then( m => m.OrganizationStatsPage)
  },
  {
    path: 'compta-invoices-list',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then( m => m.InvoicesListPage)
  },
  {
    path: 'compta-invoices-list/:add',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then( m => m.InvoicesListPage)
  },
  {
    path: 'compta-invoices-list/:add/:fromPhoto',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then( m => m.InvoicesListPage)
  },
  {
    path: 'discussion-list',
    loadComponent: () => import('./discussion/discussion-list/discussion-list.page').then( m => m.DiscussionListPage)
  },
  {
    path: 'discussion-new/:userId',
    loadComponent: () => import('./discussion/discussion-new/discussion-new.page').then( m => m.DiscussionNewPage)
  },
  {
    path: 'discussion-new',
    loadComponent: () => import('./discussion/discussion-new/discussion-new.page').then( m => m.DiscussionNewPage)
  },
  {
    path: 'discussion-pool-edit/:discussionId',
    loadComponent: () => import('./discussion/discussion-pool-edit/discussion-pool-edit.page').then( m => m.DiscussionPoolEditPage)
  },
  {
    path: 'discussion-pool-edit/:discussionId/:poolId',
    loadComponent: () => import('./discussion/discussion-pool-edit/discussion-pool-edit.page').then( m => m.DiscussionPoolEditPage)
  },
  {
    path: 'discussion-post/:discussionId',
    loadComponent: () => import('./discussion/discussion-post/discussion-post.page').then( m => m.DiscussionPostPage)
  },
  {
    path: 'user-profil-public-animals/:userIdentifier',
    loadComponent: () => import('./userProfile/user-profil-public-animals/user-profil-public-animals.page').then( m => m.UserProfilPublicAnimalsPage)
  },
  {
    path: 'redirect-to-store',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then( m => m.RedirectToStorePage)
  },
  {
    path: 'telechargez-lapplication',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then( m => m.RedirectToStorePage)
  },
  {
    path: 'download',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then( m => m.RedirectToStorePage)
  },
  {
    path: 'animal-death/:animalId',
    loadComponent: () => import('./animal/animal-death/animal-death.page').then( m => m.AnimalDeathPage)
  },
  {
    path: 'organization-subscription',
    loadComponent: () => import('./organization/organization-subscription/organization-subscription.page').then( m => m.OrganizationSubscriptionPage)
  },
  {
    path: 'litter-list',
    loadComponent: () => import('./litter/litter-list/litter-list.page').then( m => m.LitterListPage)
  },
  {
    path: 'litter-update',
    loadComponent: () => import('./litter/litter-update/litter-update.page').then( m => m.LitterUpdatePage)
  },
  {
    path: 'litter-update/:litterId',
    loadComponent: () => import('./litter/litter-update/litter-update.page').then( m => m.LitterUpdatePage)
  },
  {
    path: 'litter-fiche/:litterId',
    loadComponent: () => import('./litter/litter-fiche/litter-fiche.page').then( m => m.LitterFichePage)
  },
];
